__turbopack_context__.v({
  "footer": "klVljG_footer",
});
